<template>
<div>
    <v-tabs v-model="tab">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab>{{ $t('views.main.orders.orders.new') }} / {{ $t('views.main.orders.orders.in_preparation') }}</v-tab>
        <v-tab>{{ $t('views.main.orders.orders.prepared') }} / {{ $t('views.main.orders.orders.sent') }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
        <v-tab-item>
            <orders-list></orders-list>
        </v-tab-item>
        <v-tab-item>
            <orders-closed-list></orders-closed-list>
        </v-tab-item>
    </v-tabs-items>
</div>
</template>

<script>
import OrdersList from "../../../components/OrdersList";
import OrdersClosedList from "../../../components/OrdersClosedList";

export default {
    name: "Orders",

    components: {
        OrdersList,
        OrdersClosedList,
    },

    data() {
        return {
            tab: null,
        }
    },
}
</script>

<style scoped>

</style>
